<template>
  <div class="animated fadeIn">
    <div id="snackbar" style="color:red;"></div>
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong> Static Pages</strong>
            <small>Form</small>
          </div>
          <b-form ref="popupform" v-on:submit.prevent.self="submitFinalData">
            <b-row>
              <div class="col-lg-4 col-xl-3 align-self-center mb-4">
                <b-form-group>
                  <multiselect
                    ref="main_name"
                    v-model="pagesList.main_name"
                    :disabled="editMode ? true : false"
                    :multiple="false"
                    :options="pageList"
                    label="pop_name"
                    placeholder="Select Type"
                    track-by="pop_id"
                    @select="popupSelect"
                  ></multiselect>
                  <label
                    v-if="error.mpm_id_error_msg"
                    style="color:red !important;"
                    >please select type</label
                  >
                </b-form-group>
              </div>
              <div class="col-lg-4 col-xl-3 align-self-center mb-4">
                <b-form-group>
                  <multiselect
                    v-model="pagesList.language"
                    :disabled="$route.query.mpm_id ? true : false"
                    :multiple="false"
                    :options="LanguageArray"
                    label="lang_name"
                    placeholder="Select Language"
                    track-by="lang_id"
                  ></multiselect>
                  <label
                    v-if="error.language_error_msg"
                    style="color:red !important;"
                    >please select language</label
                  >
                </b-form-group>
              </div>
              <div
                v-if="popupType == 2"
                class="col-lg-4 col-xl-3 align-self-center mb-4"
              >
                <b-form-group>
                  <multiselect
                    v-model="pagesList.ratingType"
                    :disabled="$route.query.mpm_id ? true : false"
                    :multiple="false"
                    :options="Ratings"
                    label="rat_name"
                    placeholder="Select Rating Type"
                    track-by="rat_id"
                  ></multiselect>
                  <label
                    v-if="error.ratingType_error_msg"
                    style="color:red !important;"
                    >please select rating</label
                  >
                </b-form-group>
              </div>

              <div
                v-if="popupType == 2 || popupType == 1 || popupType == 0"
                class="col-lg-4 col-xl-3 align-self-center mb-4"
              >
                <b-form-group>
                  <label for="logo">
                    Banners
                    <br />Size: {{ imageSize.width }}*{{ imageSize.height }}
                  </label>
                  <input
                    ref="fileinput"
                    :disabled="popupType == 0"
                    accept="image/jpeg, image/png, image/gif"
                    multiple
                    name="image_arr"
                    type="file"
                    v-on:change="uploadBanner($event.target)"
                  />
                  <input v-model="pagesList.banner" type="hidden" />
                </b-form-group>
                <div
                  v-if="pagesList.banner"
                  style="cursor: pointer"
                  @click="seeImagesFill('banner', -1)"
                >
                  <u>See {{ pagesList.banner.split(",").length }} images</u>
                </div>
                <label
                  v-if="error.banner_error_msg"
                  style="color:red !important;"
                  >please select image</label
                >
              </div>
              <div class="col-lg-4 col-xl-3 align-self-center mb-4">
                <b-form-group>
                  <div class="input-material mt-2">
                    <b-form-input
                      id="poptitle"
                      v-model="pagesList.popup_rating_title"
                      placeholder="pop title"
                      type="text"
                    ></b-form-input>
                    <label>Pop up title</label>
                  </div>
                </b-form-group>
                <label
                  v-if="error.popup_rating_title_error_msg"
                  style="color:red !important;"
                  >title is required</label
                >
              </div>

              <div
                v-if="popupType == 3"
                class="col-lg-4 col-xl-3 align-self-center mb-4"
              >
                <b-form-group>
                  <div class="input-material mt-2">
                    <b-form-input
                      id="welcome_url"
                      v-model="pagesList.welcome_url"
                      placeholder="welcome url"
                      type="text"
                    ></b-form-input>
                    <label>Welcome URL</label>
                  </div>
                </b-form-group>
              </div>

              <div class="col-lg-4 col-xl-3 align-self-center mb-4">
                <b-form-group>
                  <multiselect
                    v-model="pagesList.country_id"
                    :disabled="$route.query.mpm_id ? true : false"
                    :multiple="true"
                    :options="countryOptions"
                    label="country_name"
                    placeholder="Select Country"
                    track-by="country_id"
                    :close-on-select="false"
                    :limit="2"
                    :limit-text="count => `& +${count} More`"
                  ></multiselect>
                  <!-- @select="popupSelect" -->
                </b-form-group>
                <label
                  v-if="error.country_id_error_msg"
                  style="color:red !important;"
                  >country is required</label
                >
              </div>
              <div class="col-lg-4 col-xl-3 align-self-center mb-4">
                <b-form-group>
                  <multiselect
                    v-model="pagesList.cinema_ids"
                    :close-on-select="false"
                    :disabled="$route.query.mpm_id ? true : false"
                    :multiple="true"
                    :options="cinemaOptions"
                    label="cine_name"
                    placeholder="Select Cinema"
                    track-by="cine_id"
                    :limit="2"
                    :limit-text="count => `& +${count} More`"
                  ></multiselect>
                  <!-- @select="popupSelect" -->
                </b-form-group>
              </div>
              <div
                v-if="popupType == 1"
                class="col-lg-4 col-xl-3 align-self-center mb-4"
              >
                <b-form-group>
                  <div class="input-material">
                    <b-form-input
                      id="poptitle"
                      v-model="pagesList.popup_rating_url"
                      placeholder="pop url"
                      type="text"
                    ></b-form-input>
                    <label>Popup Banner Image Url</label>
                  </div>
                </b-form-group>
                <!-- <label
                  v-if="error.popup_rating_url_error_msg"
                  style="color:red !important;"
                  >redirect url is required</label
                > -->
              </div>

              <!--From Date-->
              <div
                class="col-lg-4 col-xl-3 align-self-center mb-4"
                v-if="pagesList.main_name.pop_id == 1 && checkEmpireClient"
              >
                <div class="input-material">
                  <div class="add-datepicker">
                    <button
                      class="btn-clearDate"
                      v-if="pagesList.fromDate"
                      @click="pagesList.fromDate = ''"
                    >
                      <!-- v-on:click="clear_from_date()" -->
                      ✖
                    </button>
                    <Datepicker
                      :monday-first="true"
                      type="date"
                      ref="programaticOpen"
                      v-model="pagesList.fromDate"
                      v-validate="'required'"
                      :disabled-dates="disabledDates"
                    ></Datepicker>
                    <label :class="pagesList.fromDate ? 'active' : ''">
                      <!-- {{ $t("show") }} -->
                      {{ $t("fromdate") }}
                    </label>
                  </div>
                </div>
                <label
                  v-if="error.popup_fromdate_error"
                  style="color:red !important;"
                  >From Date is required</label
                >
              </div>

              <!--Todate-->

              <div
                class="col-lg-4 col-xl-3 align-self-center mb-4"
                v-if="pagesList.main_name.pop_id == 1 && checkEmpireClient"
              >
                <div class="input-material">
                  <div class="add-datepicker">
                    <button
                      class="btn-clearDate"
                      v-if="pagesList.toDate"
                      @click="pagesList.toDate = ''"
                    >
                      <!-- v-on:click="clear_to_date()" -->
                      ✖
                    </button>
                    <Datepicker
                      :monday-first="true"
                      type="date"
                      ref="programaticOpen"
                      v-model="pagesList.toDate"
                      v-validate="'required'"
                      :disabled-dates="disabledDates"
                    ></Datepicker>
                    <label :class="pagesList.toDate ? 'active' : ''">
                      <!-- {{ $t("show") }} -->
                      {{ $t("todate") }}
                    </label>
                  </div>
                </div>
                <label
                  v-if="error.popup_date_error"
                  style="color:red !important;"
                  >To Date Cannot be less the from date</label
                >
              </div>

              <div class="col-lg-4 col-xl-3 align-self-center mb-4">
                <b-form-checkbox
                  v-model="pagesList.isActive"
                  class="j-checkbox ml-3 mb-3"
                  unchecked-value="N"
                  value="Y"
                >
                  Is Active
                </b-form-checkbox>
                <!-- <label style="color:red !important;" v-if="error.isActive_error_msg">isActive is required</label> -->
              </div>
              <div class="input-material-textarea">
                <div
                  v-if="popupType != 1"
                  class="col-lg-12 align-self-center mb-4"
                >
                  <div class="descriptionSection font-weight-bold fs-14 mb-3">
                    Description
                  </div>
                  <div v-if="isEdit" class="">
                    <vue-editor
                      id="page"
                      v-model="pagesList.description"
                      name="page"
                    ></vue-editor>
                  </div>
                </div>
              </div>
              <label
                v-if="error.description_error_msg"
                class="col-lg-12 align-self-center"
                style="color:red !important;"
                >Description is required</label
              >
            </b-row>

            <b-row
              class="m-2"
              v-if="
                $can('create', 'Add Pop Up Pages') ||
                  $can('update', 'Add Pop Up Pages')
              "
            >
              <b-col sm="4">
                <b-button
                  :disabled="popupType == 0"
                  size="sm"
                  type="submit"
                  variant="primary"
                >
                  <i class="fa fa-dot-circle-o"></i>
                  Add
                </b-button>
              </b-col>
              <b-col sm="4">
                <b-button
                  size="sm"
                  variant="success"
                  @click="resetStaticBanner"
                >
                  <i class="fa fa-dot-circle-o"></i> Reset
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <div>
      <b-modal
        id="modalPopover"
        ref="showImages"
        title="See Images"
        @ok="onOkay"
      >
        <div>
          <draggable
            ref="bannerImg"
            v-model="bannerImg"
            class="d-flex justify-content-center flex-wrap"
            group="image"
            @end="drag = false"
            @start="drag = true"
          >
            <div
              v-for="(item, index) in bannerImg"
              :key="index"
              class="m-2"
              sm="4"
            >
              <img
                :src="
                  item.startsWith('http')
                    ? item.replace(/([^:]\/)\/+/g, '$1')
                    : IMGBASEURL + item
                "
                style="width:100px;height:100px"
              />
              <div class="m-2">
                <button class="btn-blue" @click="removeImagesFill(index)">
                  Remove
                </button>
              </div>
            </div>
          </draggable>
        </div>
      </b-modal>
    </div>
    <b-modal
      id="ModalConfirmationOnSubmit"
      ref="ModalConfirmationOnSubmit"
      :title="modalObject.title"
      cancel-variant="outline-danger"
      centered
      class="center-footer"
      footer-class="justify-content-center border-0"
      hide-header
      no-close-on-backdrop
      no-close-on-esc
      ok-variant="outline-success"
      @ok="handleModalOkay"
    >
      <div class="d-block text-center">
        <div>{{ modalObject.message }}</div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import MasterService from "@/services/MasterService";
import ExhibitorService from "@/services/ExhibitorService";
import { VueEditor } from "vue2-editor";
import { BASEURL, IMGBASEURL } from "@/config/index";
import moment from "moment";
import { CLIENT_NAME } from "@/helper/Role";

export default {
  name: "AddPopupPages",
  data() {
    return {
      disabledDates: {
        to: new Date(Date.now() - 864e5)
      },
      currentDate: "",
      IMGBASEURL: IMGBASEURL,
      editMode: false,
      bannerType: "",
      bannerIndex: "",
      BaseURL: "",
      Ratings: [],
      isEdit: true,
      staticNames: {
        name: "Add"
      },
      modalObject: {
        title: "fdsfds"
      },
      cinemaListArray: [],
      popupType: 0,
      countryOptions: [],
      cinemaOptions: [],
      LanguageArray: [],
      pageList: [
        { pop_id: 3, pop_name: "Welcome" },
        { pop_id: 1, pop_name: "Popup" },
        { pop_id: 2, pop_name: "Rating" }
      ],
      pagesList: {
        pp_id: "",
        mpm_id: "",
        main_name: "",
        country_id: "",
        cinema_ids: "",
        description: "",
        language: "",
        popup_rating_url: "",
        isActive: false,
        popup_rating_title: "",
        banner: "",
        status: "Y",
        ratingType: "",
        welcome_url: "",
        fromDate: "",
        toDate: ""
      },
      error: {
        mpm_id_error_msg: false,
        main_name_error_msg: false,
        country_id_error_msg: false,
        description_error_msg: false,
        language_error_msg: false,
        popup_rating_url_error_msg: false,
        isActive_error_msg: false,
        popup_rating_title_error_msg: false,
        banner_error_msg: false,
        status_error_msg: false,
        ratingType_error_msg: false,
        popup_fromdate_error: false,
        popup_date_error: false
      },
      imageSize: {
        width: 125,
        height: 125
      },

      imagesVmodel: "",
      imagesIndex: "",
      bannerImg: []
    };
  },
  components: {
    VueEditor,
    draggable
  },
  computed: {
    checkEmpireClient() {
      return (
        CLIENT_NAME.EMPIRE == this.CLIENT_SETUP_NAME ||
        CLIENT_NAME.STAR == this.CLIENT_SETUP_NAME
      );
    }
  },
  watch: {
    "pagesList.main_name"(newValue) {
      console.log("watcher:", newValue);
      if (newValue == null) {
        this.popupType = 0;
      } else {
        this.popupType = newValue ? newValue.pop_id : "";
      }
    }
  },
  async beforeMount() {
    const { movieId, mpm_id } = this.$route.query;
    if (this.$route.query.pp_id) {
      this.editMode = true;
    }
    await this.getActiveCinemas();
    await this.getRatingList();
    await this.getLanguagesList();
    await this.getActiveCountries();
  },
  mounted: function() {},
  methods: {
    moment,
    clear_to_date() {
      this.pageList.toDate = "";
    },
    clear_from_date() {
      this.pageList.fromDate = "";
    },
    getPopupData(id) {
      const payload = id;
      ExhibitorService.getSinglePopup(payload)
        .then(response => {
          const { data } = response;

          if (data.status && data.Records.length > 0) {
            let popupData = data.Records[0];
            let countryArr =
              popupData.pp_country_id != ""
                ? popupData.pp_country_id.split(",")
                : "";
            let cineArr =
              popupData.pp_cinema_ids && popupData.pp_cinema_ids != ""
                ? popupData.pp_cinema_ids.split(",")
                : [];

            let main_name = this.pageList.filter(
              objVal => objVal.pop_id == popupData.pp_type_id
            );
            let country_id = this.countryOptions.filter(objVal =>
              countryArr.includes(`${objVal.country_id}`)
            );
            let cinema_ids = this.cinemaOptions.filter(objVal =>
              cineArr.includes(`${objVal.cine_id}`)
            );
            let description = popupData.pp_description;
            let language = this.LanguageArray.filter(
              objVal => objVal.lang_id == popupData.pp_lang_id
            );
            let popupUrl = popupData.pp_image_url;
            let isActive = popupData.is_active;
            let pp_rating_type = this.Ratings.filter(
              objVal => objVal.rat_id == popupData.pp_rating_type
            )[0];
            // const ImageUrl = popupData.pp_banner;
            // const cleanedImageUrl = ImageUrl.replace(/([^:])\/{2,}/g, "$1/");
            let pp_banner = popupData.pp_banner;
            let pp_title = popupData.pp_title;
            let pp_id = popupData.pp_id;
            let fromDate = popupData.fromDate;
            let toDate = popupData.toDate;
            this.pagesList = {
              mpm_id: "",
              pp_id: pp_id,
              main_name: main_name[0],
              country_id: country_id,
              cinema_ids: cinema_ids,
              description: description,
              language: language[0],
              popup_rating_url: popupUrl,
              isActive: isActive,
              popup_rating_title: pp_title,
              banner: pp_banner,
              ratingType: pp_rating_type,
              fromDate: fromDate,
              toDate: toDate
            };

            if (main_name[0].pop_id == 1) {
              this.imageSize.width = 466;
              this.imageSize.height = 583;
            } else if (main_name[0].pop_id == 2) {
              this.imageSize.width = 125;
              this.imageSize.height = 125;
            } else if (main_name[0].pop_id == 3) {
              this.imageSize.width = 466;
              this.imageSize.height = 583;
              this.pagesList.welcome_url = popupUrl;
            }
          } else {
            // Show Errors
            //console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          //console.log("show error :", error);
        });
    },
    onOkay() {
      if (this.imagesIndex < 0) {
        this.pagesList[this.bannerType] = this.bannerImg.join(",");
      } else {
        this.pagesList.otherData[this.bannerIndex][
          this.bannerType
        ] = this.bannerImg.join(",");
      }
    },
    seeImagesFill(model_name, index) {
      this.imagesIndex = index;
      this.imagesVmodel = model_name;
      this.bannerType = model_name;
      this.bannerIndex = index;
      if (this.imagesIndex < 0) {
        this.bannerImg = this.pagesList[this.imagesVmodel].split(",");
      } else {
        this.bannerImg = this.pagesList.otherData[this.imagesIndex][
          this.imagesVmodel
        ].split(",");
      }
      this.$refs.showImages.show();
    },
    removeImagesFill(index) {
      this.imagesIndex = -1;
      this.imagesVmodel = "banner";

      this.bannerImg.splice(index, 1);

      if (this.imagesIndex < 0) {
        this.pagesList[this.imagesVmodel] = this.bannerImg.join(",");
      } else {
        this.pagesList.otherData[this.imagesIndex][
          this.imagesVmodel
        ] = this.bannerImg.join(",");
      }

      this.$refs.showImages.hide();
    },
    addBannerFormat() {
      let obj = {
        main_name: "",
        header_name: "",
        description: "",
        images: "",
        cover_image: "",
        o_status: "Y"
      };
      this.pagesList.otherData.push(obj);
    },
    removeBannerImage(index) {
      this.pagesList.otherData[index]["o_status"] = "N";
    },
    getRatingList: function() {
      let payload = {
        tableName: "ms_ratings",
        rating_is_active: "Y"
      };
      if (this.Ratings.length === 0) {
        MasterService.GetActiveList(payload)
          .then(response => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Ratings = data.Records.map((value, index) => ({
                rat_id: value.rating_id,
                rat_name: value.rating
              }));

              //console.log(this.Ratings,data.Records);
            } else {
              // Show Errors
              //console.log("show error :", data.message);
            }
          })
          .catch(error => {
            // Show Catch Error
            //console.log("show error :", error);
          });
      }
    },
    popupSelect: function(popupList) {
      //get Rating Types..
      if (popupList.pop_id == 1) {
        this.popupType = popupList.pop_id;
        this.imageSize.width = 466;
        this.imageSize.height = 583;
        this.removeImagesFill(0);
      } else if (popupList.pop_id == 2) {
        this.popupType = popupList.pop_id;
        this.imageSize.width = 125;
        this.imageSize.height = 125;
        this.removeImagesFill(0);
        console.log(this.popupType);
      }
      //console.log(this.pagesList);
    },
    getLanguagesList: function() {
      // getCountriesList

      let payload = {
        tableName: "ms_language",
        lang_is_active: "Y"
      };
      return MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            //console.log("langres", data.Records);
            this.LanguageArray = data.Records;
          } else {
            //console.log("Error from language", data.message);
          }
        })
        .catch(error => {
          //console.log(error, "from language catch");
        });
    },

    selectAllCinema: function(cinemaList) {
      if (cinemaList.CinemaName == "All") {
        setTimeout(x => {
          this.staticBanner.CinemaIDArray = this.cinemaListArray.filter(x => {
            return parseInt(x.CinemaID) > 0;
          });
        }, 100);
      }
    },
    getBannersDetails: function(pageid) {
      let payload = {
        pageid
      };

      return false;
    },
    submitStaticBanner: function() {
      if (!this.staticBanner.pagename) {
        this.showMessageSnackbar("Please Select Any Movie");
      } else if (!this.staticBanner.LanguageID) {
        this.showMessageSnackbar("Please Select Any Language");
      } else if (!this.staticBanner.banners) {
        this.showMessageSnackbar("Please Select Banner Image");
      } else {
        let payload = {
          title: "Confirmation",
          message: "Please re-check the data before submit"
        };
        this.showSubmitConfirmation(payload);
      }
    },

    uploadAppThumbBanner: function(image) {
      let refs = this.$refs;
      var self = this;
      var _URL = window.URL || window.webkitURL;
      var file, img;
      if ((file = image.files[0])) {
        img = new Image();
        img.src = _URL.createObjectURL(file);
        img.onload = async function() {
          // if (img.height != 254 || img.width != 179) {
          //   // if (false) {
          //   self.$refs["fileinput"].reset();
          //   self.showMessageSnackbar("Please upload a 1520x500 image");
          // } else {
          var formdata = new FormData();
          formdata.append("assets/images/movies/banners", image.files[0]);
          UploadService.uploadFiles(formdata)
            .then(response => {
              response.data.Message
                ? self.showMessageSnackbar(response.data.Message)
                : "";

              if (response.data.Status) {
                self.staticBanner.appthumbimage = response.data.Path;
                self.BaseURL = response.data.BaseURL;
              }
            })
            .catch(error => {
              //console.log("Catch on AddStaticImages-onUpload Error: ", error);
              self.showMessageSnackbar(
                "Oops! Something went wrong. kindly contact your administrator"
              );
            });
          // }
        };
      }
    },

    uploadMobileBanner: function(image) {
      let refs = this.$refs;
      var self = this;
      var _URL = window.URL || window.webkitURL;
      var file, img;
      if ((file = image.files[0])) {
        img = new Image();
        img.src = _URL.createObjectURL(file);
        img.onload = async function() {
          if (
            img.height != this.imageSize.height ||
            img.width != this.imageSize.width
          ) {
            // if (false) {
            // self.$refs["fileinput"].reset();
            self.showMessageSnackbar("Please upload a 400x500 image");
          } else {
            var formdata = new FormData();
            formdata.append("assets/images/movies/banners", image.files[0]);
            UploadService.uploadFiles(formdata)
              .then(response => {
                response.data.Message
                  ? self.showMessageSnackbar(response.data.Message)
                  : "";

                if (response.data.Status) {
                  self.staticBanner.appbanner = response.data.Path;
                  self.BaseURL = response.data.BaseURL;
                }
              })
              .catch(error => {
                //console.log("Catch on AddStaticImages-onUpload Error: ", error);
                self.showMessageSnackbar(
                  "Oops! Something went wrong. kindly contact your administrator"
                );
              });
          }
        };
      }
    },

    resetStaticBanner: function() {
      this.pagesList.country_id = "";
      this.pagesList.cinema_ids = "";
      this.pagesList.language = "";
      this.pagesList.ratingType = "";
      this.pagesList.popup_rating_url = "";
      this.pagesList.popup_rating_title = "";
      this.pagesList.welcome_url = "";
      // this.bannerImg = [];
      this.pagesList.description = "";
      this.removeImagesFill(0);
      this.$refs.popupform.reset();
    },
    // Show Confirmmation Dialog
    handleModalOkay: function(evt) {
      // evt.preventDefault();
      this.modalObject.count = 1;
      this.submitFinalData();
    },
    showSubmitConfirmation: function(payload) {
      this.modalObject.title = payload.title; // "Confirmation";
      this.modalObject.message = payload.message; // "Please re-check the data before submit";
      this.openModal("ModalConfirmationOnSubmit");
    },
    openModal: function(ref) {
      this.$refs[ref].show();
    },
    closeModal: function(ref) {
      this.$refs[ref].hide();
      this.modalObject.title = ""; // "Confirmation";
      this.modalObject.message = ""; // "Please re-check the data before submit";
    },
    // Show Confirmmation Dialog End
    // Show Error Message
    showMessageSnackbar: function(Message) {
      let x = document.getElementById("snackbar");
      x.className = "show";
      x.innerHTML = Message;
      setTimeout(function() {
        x.className = "";
        x.innerHTML = "";
      }, 6000);
    },
    uploadBanner: function(image) {
      //console.log(image.files);
      let refs = this.$refs;
      var self = this;
      var _URL = this.BASE_URL;
      var file, img;
      if ((file = image.files[0])) {
        img = new Image();

        let img_data = "";
        var files = image.files;
        var file = image.files[0];

        var width, height;
        let reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onload = evt => {
          let img = new Image();
          img.onload = () => {
            console.log(img.width, img.height, "hdhdh");

            console.log(image, "height:", img.height, "width:", img.width);
            if (
              img.height != this.imageSize.height ||
              img.width != this.imageSize.width
            ) {
              self.showMessageSnackbar(
                `Please upload a ${this.imageSize.width}x${this.imageSize.height} image`
              );
            } else {
              const formData = new FormData();
              for (const i of Object.keys(files)) {
                //console.log("imagesformdata", `${_URL}/uploads/${files[i].name}`);
                formData.append("image_arr", files[i]);
              }
              ExhibitorService.MultipleImages(formData)
                .then(response => {
                  //console.log(response);
                  const { data } = response;
                  this.bannerImg = data.path;

                  this.pagesList.banner = this.bannerImg.toString();

                  //console.log(this.pagesList.banner, "bannerImg");
                })
                .catch(error => {
                  //console.log(error);
                });
            }
          };
          img.src = evt.target.result;
        };
      }
    },
    uploadImageHandler: function(image, name, size, index) {
      //console.log(image.files);
      let refs = this.$refs;
      var self = this;
      var _URL = this.BASE_URL;
      var file, img;
      if ((file = image.files[0])) {
        img = new Image();

        let img_data = "";
        var files = image.files;

        const formData = new FormData();
        for (const i of Object.keys(files)) {
          formData.append("image_arr", files[i]);
        }
        ExhibitorService.MultipleImages(formData)
          .then(response => {
            //console.log(response);
            const { data } = response;
            this.bannerImg = data.path;
            this.pagesList.otherData[index][name] = this.bannerImg.toString();

            //console.log(this.pagesList.otherData[index][name], "bannerImg");
          })
          .catch(error => {
            //console.log(error);
          });
      }
    },
    getActiveCinemas() {
      this.cinemaOptions = [];

      return MasterService.GetActiveList({
        tableName: "ms_cinemas",
        cine_is_active: "Y"
      })
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.cinemaOptions = data.Records;
            }
          }
        })
        .catch(e => {
          this.cinemaOptions = [];
          this.$toasted.show(data.message || "Something went wrong!");
        });
    },
    getActiveCountries(country_id, flag) {
      let body = {
        tableName: "ms_countries",
        country_is_active: "Y"
      };
      MasterService.GetActiveList(body)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.countryOptions = data.Records;
              //console.log("this.ActiveCountries :>> ", this.countryOptions);
              if (this.editMode) {
                this.getPopupData(this.$route.query.pp_id);
              }
            }
          }
          // else
          // this.$toasted.show(data.message || "Opps! Something went wrong");
        })
        .catch(this._CatchError);
    },
    validateData() {
      if (this.pagesList.main_name.pop_id == 1) {
        //Language Validation

        if (!this.pagesList.language) {
          this.error.language_error_msg = true;
          return false;
        } else if (!this.pagesList.language.lang_id) {
          this.error.language_error_msg = true;
          return false;
        } else {
          this.error.language_error_msg = false;
        }

        //Banner Validation

        if (!this.pagesList.banner) {
          console.log("hello");
          this.error.banner_error_msg = true;
          return false;
        } else {
          this.error.banner_error_msg = false;
        }

        //Title Validation

        if (!this.pagesList.popup_rating_title) {
          console.log("hello");
          this.error.popup_rating_title_error_msg = true;
          return false;
        } else {
          this.error.popup_rating_title_error_msg = false;
        }

        //Country Validation

        if (!this.pagesList.country_id.length > 0) {
          this.error.country_id_error_msg = true;
          return false;
        } else {
          this.error.country_id_error_msg = false;
        }
        if (this.pagesList.formData == "") {
          console.log("hello");
          this.error.popup_fromdate_error = true;
          return false;
        } else {
          this.error.popup_fromdate_error = false;
        }
        if (
          moment(this.pagesList.toDate).format("YYYY-MM-DD") <
          moment(this.pagesList.fromDate).format("YYYY-MM-DD")
        ) {
          console.log("hello");
          this.error.popup_date_error = true;
          return false;
        } else {
          this.error.popup_date_error = false;
        }
        //Banner URL Validation

        // if (!this.pagesList.popup_rating_url.length > 0) {
        //   this.error.popup_rating_url_error_msg = true;
        //   return false;
        // } else {
        //   this.error.popup_rating_url_error_msg = false;
        // }

        // Verification Done!
        return true;
      } else if (this.pagesList.main_name.pop_id == 2) {
        if (!this.pagesList.language) {
          this.error.language_error_msg = true;
          return false;
        } else if (!this.pagesList.language.lang_id) {
          this.error.language_error_msg = true;
          return false;
        } else {
          this.error.language_error_msg = false;
        }

        //Rating Validation
        console.log(this.pagesList.ratingType);

        if (!this.pagesList.ratingType) {
          this.error.ratingType_error_msg = true;
          return false;
        } else if (!this.pagesList.ratingType.rat_id) {
          this.error.ratingType_error_msg = true;
          return false;
        } else {
          this.error.ratingType_error_msg = false;
        }

        //Banner Validation

        if (!this.pagesList.banner) {
          console.log("hello");
          this.error.banner_error_msg = true;
          return false;
        } else {
          this.error.banner_error_msg = false;
        }

        //Title Validation

        if (!this.pagesList.popup_rating_title) {
          console.log("hello");
          this.error.popup_rating_title_error_msg = true;
          return false;
        } else {
          this.error.popup_rating_title_error_msg = false;
        }

        //Country Validation

        if (!this.pagesList.country_id.length > 0) {
          this.error.country_id_error_msg = true;
          return false;
        } else {
          this.error.country_id_error_msg = false;
        }

        //Description Validation

        if (!this.pagesList.description) {
          console.log("hello");
          this.error.description_error_msg = true;
          return false;
        } else {
          this.error.description_error_msg = false;
        }

        // Verification Done!
        return true;
      } else if (this.pagesList.main_name.pop_id == 3) {
        if (!this.pagesList.language) {
          this.error.language_error_msg = true;
          return false;
        } else if (!this.pagesList.language.lang_id) {
          this.error.language_error_msg = true;
          return false;
        } else {
          this.error.language_error_msg = false;
        }

        //Title Validation
        if (!this.pagesList.popup_rating_title) {
          this.error.popup_rating_title_error_msg = true;
          return false;
        } else {
          this.error.popup_rating_title_error_msg = false;
        }

        //Country Validation
        if (!this.pagesList.country_id.length > 0) {
          this.error.country_id_error_msg = true;
          return false;
        } else {
          this.error.country_id_error_msg = false;
        }

        //Description Validation
        if (!this.pagesList.description) {
          console.log("hello");
          this.error.description_error_msg = true;
          return false;
        } else {
          this.error.description_error_msg = false;
        }

        // Verification Done!
        return true;
      } else {
        if (this.pagesList.main_name.pop_id) {
          return false;
        }
      }
    },
    submitFinalData() {
      if (this.validateData()) {
        let loader = this.$loading.show();
        let testArr = [];
        let all_country_ids = Array.isArray(this.pagesList.country_id)
          ? this.pagesList.country_id.map(v => v.country_id).join(",")
          : "";
        let all_cinema_ids = Array.isArray(this.pagesList.cinema_ids)
          ? this.pagesList.cinema_ids.map(v => v.cine_id).join(",")
          : "";

        const popupData = {
          pp_id: this.editMode ? this.pagesList.pp_id : undefined,
          pp_type_id:
            this.pagesList.main_name && this.pagesList.main_name.pop_id
              ? this.pagesList.main_name.pop_id
              : "",
          pp_name:
            this.pagesList.main_name && this.pagesList.main_name.pop_name
              ? this.pagesList.main_name.pop_name
              : "",
          pp_lang_id:
            this.pagesList.language && this.pagesList.language.lang_id
              ? this.pagesList.language.lang_id
              : "",
          pp_rating_type:
            this.pagesList.ratingType && this.pagesList.ratingType.rat_id
              ? this.pagesList.ratingType.rat_id
              : "",
          pp_banner: this.pagesList.banner.startsWith("http")
            ? new URL(this.pagesList.banner).pathname
            : this.pagesList.banner,
          pp_title: this.pagesList.popup_rating_title,
          pp_country_id: all_country_ids,
          pp_cinema_ids: all_cinema_ids,
          pp_image_url: this.pagesList.popup_rating_url,
          pp_description: this.pagesList.description,
          is_active: this.pagesList.isActive,
          fromDate: this.pagesList.fromDate
            ? moment(this.pagesList.fromDate).format("YYYY-MM-DD")
            : null,
          toDate: this.pagesList.toDate
            ? moment(this.pagesList.toDate).format("YYYY-MM-DD")
            : null
        };

        if (this.pagesList.main_name.pop_id == 3) {
          popupData.pp_image_url = this.pagesList.welcome_url || "";
        }

        testArr.push(popupData);
        let payload = {
          popupPages: testArr
        };
        //console.log(payload);
        ExhibitorService.AddPopup(payload)
          .then(response => {
            const { data } = response;
            if (!this.editMode) {
              this.resetStaticBanner();
            }
            this.$toasted.show(data.message);
            this.$router.go(-1);
          })
          .catch(err => {
            //console.log(err);
          })
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      } else {
        console.error("Validation Error");
      }
    }
  },
  updated() {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/add-popup-pages.vue